import { createContext, useContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(sessionStorage.getItem("reallyfan_token"));
  const [loading, setLoading] = useState(true);
  const [streak, setStreak] = useState(null);

  useEffect(() => {
    if (token) {
      axios
        .get(`${API}/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
          setUser(res.data.user);
          // Auto checkin for daily streak
          return axios.post(`${API}/streak/checkin`, {}, {
            headers: { Authorization: `Bearer ${token}` },
          });
        })
        .then((res) => {
          setStreak(res.data);
          if (!res.data.already_checked_in) {
            // Refresh user to get updated credits
            return axios.get(`${API}/auth/me`, {
              headers: { Authorization: `Bearer ${token}` },
            });
          }
          return null;
        })
        .then((res) => {
          if (res) setUser(res.data.user);
        })
        .catch(() => {
          sessionStorage.removeItem("reallyfan_token");
          setToken(null);
        })
        .finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [token]);

  const login = async (email, password) => {
    const res = await axios.post(`${API}/auth/login`, { email, password });
    sessionStorage.setItem("reallyfan_token", res.data.token);
    setToken(res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const register = async (data) => {
    const res = await axios.post(`${API}/auth/register`, data);
    sessionStorage.setItem("reallyfan_token", res.data.token);
    setToken(res.data.token);
    setUser(res.data.user);
    return res.data.user;
  };

  const logout = () => {
    sessionStorage.removeItem("reallyfan_token");
    setToken(null);
    setUser(null);
    setStreak(null);
  };

  const refreshUser = useCallback(async () => {
    if (!token) return;
    try {
      const res = await axios.get(`${API}/auth/me`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setUser(res.data.user);
    } catch (err) { console.error(err); }
  }, [token]);

  const api = axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  return (
    <AuthContext.Provider
      value={{ user, token, loading, login, register, logout, api, refreshUser, streak }}
    >
      {children}
    </AuthContext.Provider>
  );
}
